import { render, staticRenderFns } from "./TinyEditor.vue?vue&type=template&id=2ce573ca&scoped=true&"
import script from "./TinyEditor.vue?vue&type=script&lang=js&"
export * from "./TinyEditor.vue?vue&type=script&lang=js&"
import style0 from "./TinyEditor.vue?vue&type=style&index=0&id=2ce573ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce573ca",
  null
  
)

export default component.exports